import { useBreakpointRange } from "@newsela/angelou";

import DataInfoCard, {
  DataInfoCardOrientation,
} from "@/components/DataInfoCard";
import {
  dataInfoCardCss,
  dataInfoCardHorizontalCss,
} from "../../OverviewDataResults.style";
import { ReadingMetricsCardProps } from "../../OverviewDataResults.type";

const ReadingMetricsCard = (props: ReadingMetricsCardProps) => {
  const {
    total,
    textContentValue,
    cardVariant,
    isClassroomPage,
    isNweaCard = false,
    displayLessThanSign = false,
    loading,
    error,
  } = props;
  const currentBreakpointRange = useBreakpointRange([
    [0, 567],
    [568, 767],
    [768, Infinity],
  ]);
  const IS_HORIZONTAL_CARD = currentBreakpointRange === "568,767";

  return (
    <DataInfoCard
      statValue={total}
      variant={cardVariant}
      textContent={textContentValue}
      additionalStyles={{
        containerCss: !IS_HORIZONTAL_CARD
          ? dataInfoCardCss(isClassroomPage)
          : dataInfoCardHorizontalCss,
      }}
      orientation={
        IS_HORIZONTAL_CARD && !isNweaCard
          ? DataInfoCardOrientation.horizontal
          : DataInfoCardOrientation.vertical
      }
      progressPercentBase={60}
      error={!!error}
      loading={!!loading}
      statValuePrefix={displayLessThanSign ? "< " : undefined}
    />
  );
};

export default ReadingMetricsCard;
